import { supabase } from '../supabaseClient';
import { assessmentAreas } from '../data/assessmentData';

// Configuration for the 3 fake organizations
const ORGS = [
  { code: 'ORG-ACME', name: 'Acme Corp', profile: 'high', threshold: 4 }, // High performers
  { code: 'ORG-GLOBEX', name: 'Globex Inc', profile: 'medium', threshold: 3 }, // Average performers
  { code: 'ORG-SOYLENT', name: 'Soylent Corp', profile: 'low', threshold: 3 } // Struggling
];

const USERS = [
  // Acme (4 users)
  { name: 'Alice Freeman', email: 'alice@acme.com', org: 'ORG-ACME' },
  { name: 'Bob Smith', email: 'bob@acme.com', org: 'ORG-ACME' },
  { name: 'Charlie Davis', email: 'charlie@acme.com', org: 'ORG-ACME' },
  { name: 'Diana Prince', email: 'diana@acme.com', org: 'ORG-ACME' },
  // Globex (3 users)
  { name: 'Evan Wright', email: 'evan@globex.com', org: 'ORG-GLOBEX' },
  { name: 'Fiona Gallagher', email: 'fiona@globex.com', org: 'ORG-GLOBEX' },
  { name: 'George Martin', email: 'george@globex.com', org: 'ORG-GLOBEX' },
  // Soylent (3 users)
  { name: 'Hannah Abbott', email: 'hannah@soylent.com', org: 'ORG-SOYLENT' },
  { name: 'Ian Malcolm', email: 'ian@soylent.com', org: 'ORG-SOYLENT' },
  { name: 'Jack Bauer', email: 'jack@soylent.com', org: 'ORG-SOYLENT' }
];

// Helper to generate a score based on profile (1-7 scale)
const generateResponse = (profile) => {
  const rand = Math.random();
  if (profile === 'high') {
    // Mostly 6s and 7s, some 5s
    return rand > 0.3 ? (rand > 0.7 ? 7 : 6) : 5;
  } else if (profile === 'medium') {
    // Mostly 3s, 4s, 5s
    return rand > 0.6 ? 5 : (rand > 0.3 ? 4 : 3);
  } else {
    // Mostly 1s, 2s, 3s
    return rand > 0.6 ? 3 : (rand > 0.3 ? 2 : 1);
  }
};

export const seedDatabase = async () => {
  console.log('🌱 Starting database seed...');
  const logs = [];
  const addLog = (msg) => { console.log(msg); logs.push(msg); };

  try {
    // 1. Insert Organizations
    addLog('Creating 3 Organizations...');
    for (const org of ORGS) {
      console.log(`Processing Org: ${org.name}`);
      const { error } = await supabase
        .from('organizations')
        .upsert({ 
          code: org.code, 
          name: org.name,
          response_threshold: org.threshold
        }, { onConflict: 'code' });
      
      if (error) {
        console.error('Supabase Error:', error);
        throw new Error(`Failed to insert org ${org.name}: ${error.message}`);
      }
    }
    addLog('✅ Organizations created.');

    // 2. Insert Users & Assessments
    addLog('Generating 10 User Assessments...');
    
    for (const user of USERS) {
      const orgProfile = ORGS.find(o => o.code === user.org).profile;
      const responses = {};
      let totalScore = 0;

      // Generate responses for all 40 questions (8 areas * 5 questions)
      assessmentAreas.forEach((area, areaIdx) => {
        area.questions.forEach((_, qIdx) => {
          const qId = `${area.id}_${qIdx}`;
          const val = generateResponse(orgProfile);
          responses[qId] = val;
          totalScore += val;
        });
      });

      // Insert Assessment
      const { error } = await supabase
        .from('assessments')
        .insert({
          org_code: user.org,
          user_name: user.name,
          user_email: user.email,
          responses: responses,
          score: totalScore,
          about_you: {
            companySize: '10-50',
            functionalRole: 'Manager',
            favoriteElements: 'Great coffee',
            motivationLevel: 5
          },
          created_at: new Date(Date.now() - Math.floor(Math.random() * 1000000000)).toISOString() // Random past date
        });

      if (error) addLog(`⚠️ Error for ${user.name}: ${error.message}`);
    }
    addLog('✅ Users and Assessments created.');
    
    return { success: true, logs };
  } catch (error) {
    console.error('Seeding Fatal Error:', error);
    addLog(`❌ Fatal Error: ${error.message}`);
    return { success: false, logs, error };
  }
};